// app/stepup/stepup.ctx.tsx
import * as React from 'react';
import { StepUpModal } from './modal';

type OpenOptions = { is2faEnabled?: boolean };
type OpenFn = (scope: string, options?: OpenOptions) => Promise<void>;

type State = {
    scope: string;
    is2faEnabled?: boolean;
} | null;

const Ctx = React.createContext<OpenFn | null>(null);

export function useStepUpOpen() {
    const fn = React.useContext(Ctx);
    if (!fn) {
        throw new Error('StepUpProvider missing');
    }
    return fn;
}

export function StepUpProvider({ children }: { children: React.ReactNode }) {
    const [ state, setState ] = React.useState<State>(null);
    const resolverRef = React.useRef<() => void>();

    const open: OpenFn = React.useCallback((s, options) => {
        setState({ scope: s, is2faEnabled: options?.is2faEnabled });
        return new Promise<void>((resolve) => {
            resolverRef.current = resolve;
        });
    }, []);

    const handleSuccess = React.useCallback(() => {
        setState(null);
        resolverRef.current?.();
        resolverRef.current = undefined;
    }, []);

    return (
        <Ctx.Provider value={open}>
            {children}
            {state && (
                <StepUpModal
                    pendingScope={state.scope}
                    is2faEnabled={state.is2faEnabled ?? false}
                    onSuccess={handleSuccess}
                />
            )}
        </Ctx.Provider>
    );
}
